<!-- Team component -->
<script>
  import { Col, Row, Container } from "sveltestrap";
  import { scrollto } from "svelte-scrollto";
</script>

<!--START PROCESS-->
<section>
  <Container>
    <Row class="mt-5">
      <Col lg="4" class="plan-line">
        <div class="text-center process-box">
          <i class="pe-7s-call" />
          <h4 class="pt-3">Free Quotes in Minutes!</h4>
          <a use:scrollto={"#contact"} href={"#contact"} class="text-primary">CALL OR EMAIL US</a>
        </div>
      </Col>      
      <Col lg="4" class="plan-line">
        <div class="text-center process-box">
          <i class="pe-7s-date" />
          <h4 class="pt-3">7 Days a Week</h4>
          <p class="text-muted">FLEXIBLE SCHEDULING</p>
        </div>
      </Col>
      <Col lg="4">
        <div class="text-center process-box">
          <i class="pe-7s-news-paper" />
          <h4 class="pt-3">Reports in 24 Hours!</h4>
          <p class="text-muted">THAT IS NOT A TYPO</p>
        </div>
      </Col>
    </Row>
  </Container>
</section>
<!--END PROCESS-->

